"use client";

import React from "react";
import Image from "next/image";
import Link from "next/link";

const AfterToothExtraction: React.FC = () => {
  return (
    <section className="w-full py-6 sm:py-8 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-6xl mx-auto px-4 sm:px-8 md:px-12 space-y-6 text-center md:text-left">
        <h2
          className="
            text-2xl sm:text-3xl font-semibold text-gray-800 text-center
            pb-6 after:content-[''] after:block after:w-[200px] after:h-[3px] after:mx-auto after:mt-2
            after:bg-[linear-gradient(to_right,#AE7D2F_0%,#ECD05B_50%,#AE7D2F_100%)]
          "
        >
          What Happens After a Tooth Extraction?
        </h2>
        <div className="my-8 mx-auto max-w-2xl rounded-lg overflow-hidden shadow-lg">
          <Image
            src="/images/photo-man-holding-cheek-with-eyes-closed-in-pain.webp"
            alt="photo-man-holding-cheek-with-eyes-closed-in-pain"
            width={800}
            height={600}
            className="w-full h-auto block"
            sizes="(max-width: 768px) 100vw, 672px"
          />
        </div>
        <p className="text-gray-700 text-base sm:text-lg leading-relaxed group hover:bg-gray-50 transition-all duration-300 rounded-md py-1">
          Recovery after a tooth extraction in Astoria, Queens, is typically
          smooth when aftercare instructions are followed closely. Simple
          extractions generally involve a few days of mild soreness, while
          surgical extractions may require up to a week of recovery time,
          depending on complexity. Dr. Khaimov&apos;s team will provide full
          written aftercare instructions before you leave the office.
        </p>
        <p className="text-gray-700 text-base sm:text-lg leading-relaxed">
          Key recovery guidelines include:
        </p>
        <ul className="list-disc list-inside space-y-3 text-gray-700 text-base sm:text-lg leading-relaxed">
          <li>
            Bite down gently on gauze immediately after the procedure to
            control bleeding and allow a clot to form.
          </li>
          <li>
            Avoid smoking, using straws, or spitting forcefully for at least
            48 hours.
          </li>
          <li>
            Eat{" "}
            <Link
              href="/blog/50-soft-foods-to-eat-after-tooth-extraction/"
              className="inline-block bg-gradient-to-r from-[#AE7D2F] via-[#ECD05B] to-[#AE7D2F] bg-clip-text text-transparent hover:underline transition-all duration-300 ease-in-out"
            >
              soft foods
            </Link>{" "}
            for the first few days, such as yogurt, mashed potatoes, smoothies,
            and soup
          </li>
          <li>
            Take pain relievers as recommended by Dr. Khaimov and apply a cold
            compress to manage swelling
          </li>
          <li>
            Watch for warning signs, including heavy bleeding, worsening pain
            after day three, or fever; contact us immediately if any of these
            occur
          </li>
        </ul>
        <p className="text-gray-700 text-base sm:text-lg leading-relaxed group hover:bg-gray-50 transition-all duration-300 rounded-md py-1">
          Once healing is complete, we&apos;ll discuss tooth replacement
          options if applicable.{" "}
          <Link
            href="/services/implant-dentistry/"
            className="inline-block bg-gradient-to-r from-[#AE7D2F] via-[#ECD05B] to-[#AE7D2F] bg-clip-text text-transparent hover:underline transition-all duration-300 ease-in-out"
          >
            Dental implants
          </Link>{" "}
          are the most natural-feeling, long-term solution for replacing a
          missing tooth, and Dr. Khaimov handles both extraction and implant
          planning under one roof.
        </p>
      </div>
    </section>
  );
};

export default AfterToothExtraction;
